import { Component, OnInit } from '@angular/core';
import { MonitorService } from '../monitor.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'lms-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss']
})
export class MetricsComponent implements OnInit {
  public metrics$: Observable<any>;

  constructor(public monitor: MonitorService) {}

  ngOnInit() {}

  getMetrics() {
    this.metrics$ = this.monitor.getMetrics();
  }
}
